import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { BannerComponent } from './banner/banner.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { HomepageComponent } from './homepage.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CarouselModule } from "primeng/carousel";
import { CarouselModule as ngxCarouselModule } from 'ngx-bootstrap/carousel';
import { SkeletonModule } from 'primeng/skeleton';
import { ClickTrackingModule } from "@pv-frontend/pv-shared-directives/tracking";
import { SvgIconModule } from '@pv-frontend/pv-shared-components/svg-icon';


const HOME_ROUTE = [
  {path: "", component: HomepageComponent},
  // {path: "offers/:category", component: HomepageComponent},
  // {path: "offers/:category/:sub_category", component: HomepageComponent},

];
@NgModule({
  declarations: [
  	BannerComponent,
    SearchBarComponent,
    HomepageComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(HOME_ROUTE),
    SharedModule,
    TabsModule.forRoot(),
    CarouselModule,
    ngxCarouselModule,
    SkeletonModule,
    ClickTrackingModule,
    SvgIconModule,
  ],
  exports: [
  	BannerComponent,
    SearchBarComponent
  ]
})
export class HomepageModule { }
